import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { APIBase } from './api.base';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';

@Injectable()
export class EmployeesAPI extends APIBase {

	constructor(@Inject(AuthHttp) authHttp: AuthHttp, @Inject(Router) router: Router, @Inject(SessionStorageService) session: SessionStorageService) {
		super(authHttp, router, session);
		// Entidade principal
		this.__entity = 'employees';
	}

	/**
 * download_report
 *
 * Relatorio de todos os campos do sistema
 *
 * @access public
 * @author Nicolas Aoki
 * @since  09/2019
 * @return object Promise
 */
	public download_report(day?, calendar?) {

		if (!calendar) {
			return this.getBlob(this.__entity + '/download_resource/', { days: day });
		} else {
			return this.getBlob(this.__entity + '/download_resource/', { calendar: calendar });
		}
    }
    /**
	 * get_employees_chart
	 *
     * Recebe os dados para formar o grafico
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  02/2020
	 * @return object Promise
	 */
	public get_employees_chart(day?) {
		return this._call(this.__entity + '/get_employees_chart/',{days:30},'get');
	}
}



// WEBPACK FOOTER //
// ./src/api/employees.api.ts